/** Shared module-level flag for pos.ecomm.checkout-widget-on-kiosk.rollout, readable from non-React code (e.g. cart.ts). */
let enabled = false;

export function setCheckoutWidgetOnKioskFlag(value: boolean): void {
  enabled = !!value;
}

export function isCheckoutWidgetOnKioskEnabled(): boolean {
  return enabled;
}
